import script from "./SpaceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceEditor.vue?vue&type=script&setup=true&lang=js"

import "./SpaceEditor.vue?vue&type=style&index=0&id=43b1a960&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b1a960"]])

export default __exports__